module.exports = __webpack_public_path__ + "static/media/32.90225433.png";